import { Inject, Injectable, Injector } from '@angular/core';

import { FootprintApiManager_ReportService } from './FootprintApiManager.report.index';


@Injectable({ providedIn: 'root' })
export class app_ReportService {

  constructor(
    private injector: Injector
  ) {
    this.FootprintApiManager = this.injector.get(FootprintApiManager_ReportService);
  }
    public FootprintApiManager: FootprintApiManager_ReportService;

  public app: app_ReportService = this;

  // injecting lazily in order to avoid circular dependencies
}

